import { CashFlow } from '@webcarrot/xirr';
import { calculatePoolIrr as packageCalculatePoolIrr } from '@foresightdata/metrics-calculator';

/**
 * Thin display adapter over the shared metrics-calculator solver (the source of truth
 * for IRR): delegates the math, keeps the UI's 2dp rounding contract.
 */
export function calculatePoolIrr(
  cashflows: readonly CashFlow[],
  terminalValue: number,
  asOfDate: Date
): number | null {
  const irr = packageCalculatePoolIrr(cashflows, terminalValue, asOfDate);

  return irr === null ? null : getValueWith2Dp(irr);
}

function getValueWith2Dp(value: number) {
  const res = Number(value.toFixed(2));

  return Object.is(res, -0) ? 0 : res;
}
